import styled from "styled-components";

export const MembershipState = styled.div`
    cursor: default;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    flex-shrink: 0;
    font-weight: 600;
    font-size: 12px;
    line-height: 1.2;
    border-radius: 6px;
    padding: 6px 10px;
    white-space: nowrap;
    border: 1px solid rgb(242, 242, 247);
    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px;
    transition: 0.2s;
    margin: 2px 0px;
    text-rendering: optimizelegibility;
    -webkit-font-smoothing: antialiased;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;

  &.active {
    background-color: #e8f5e8;
    color: #2e7d32;
  }
  
  &.paid {
    background-color: #e3f2fd;
    color: #1976d2;
  }
  
  &.paused {
    background-color: #fff3e0;
    color: #f57c00;
  }
  
  &.non_renewing {
    background-color: #fff3e0;
    color: #f57c00;
  }
  
  &.refunded {
    background-color: #ffebee;
    color: #d32f2f;
  }
  
  &.cancelled {
    background-color: #ffebee;
    color: #d32f2f;
  }
  
  &.expired {
    background-color: #f5f5f5;
    color: #757575;
  }
  
  &.pending_invite {
    background-color: #e8eaf6;
    color: #3f51b5;
  }
  
  &.defaulted {
    background-color: #ffebee;
    color: #d32f2f;
  }
  
  &.no-subscribed {
    background-color: #f5f5f5;
    color: #757575;
  }
`;

export const LeadMagnetTag = styled.div`
  cursor: default;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-shrink: 0;
  font-weight: 600;
  font-size: 12px;
  line-height: 1.2;
  border-radius: 6px;
  padding: 6px 10px;
  white-space: nowrap;
  border: 1px solid rgb(242, 242, 247);
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px;
  transition: 0.2s;
  margin: 2px 4px 2px 0px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #f3e5f5;
  color: #7b1fa2;
`;
